export default __webpack_public_path__ + "static/media/compressed.feedeb30.svg";